import { mapValues } from "lodash-es";

import yup from "@/yup";

export function useEditCategoryFormSchema() {
  return yup.object({
    names: yup.lazy((value) =>
      yup.object(
        mapValues(value, () => yup.string().min(2).default("").defined()),
      ),
    ),
    isActive: yup.boolean().defined(),
    order: yup.number().defined(),
    tag: yup
      .mixed<"header" | "menu" | "bottom" | null | undefined>()
      .oneOf(["header", "menu", "bottom", null, undefined]),
    domainIdsBlacklist: yup.array(yup.number().integer().required()).required(),
    domainIdsWhitelist: yup.array(yup.number().integer().required()).required(),
  });
}

export type EditCategoryFormSchema = yup.InferType<
  ReturnType<typeof useEditCategoryFormSchema>
>;
